import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faXTwitter, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
      

const socialMediaLinks = [
  { href: 'https://www.facebook.com/people/Integrated-Business-solutions-Zambia/61563888770037/', icon: faFacebook, color: 'text-gray-500', label: 'Facebook' },
  { href: 'https://www.twitter.com', icon: faXTwitter, color: 'text-gray-500', label: 'Twitter' },
  { href: 'https://www.linkedin.com/company/integrated-business-solutions-ltd/', icon: faLinkedin, color: 'text-gray-500', label: 'LinkedIn' },
  { href: 'https://api.whatsapp.com/send?phone=++260955362614', icon: faWhatsapp, color: 'text-[#1EDC00]', label: 'WhatsApp' }
];

function Footer() {
  return (
    <footer className="w-full bg-gray-800 text-white p-6 mt-8">
      <div className="container mx-auto">
        {/* Grid for Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-center">
          {/* Column 1: Location */}
          <div className="mb-8 flex flex-col sm:flex-row items-center justify-center md:border-r md:border-gray-600 md:pr-4">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="hover:text-[#C5B358] text-gray-300 text-4xl mb-2 sm:mb-0" />
            <div className="text-left sm:ml-4">
              <p>
                Plot No.11323A Beu Crescent <br />
                Kalundu, Lusaka,
                Zambia
              </p>
            </div>
          </div>

          {/* Column 2: Phone Numbers */}
          <div className="mb-8 flex flex-col sm:flex-row items-center justify-center md:border-r md:border-gray-600 md:pr-4">
            <FontAwesomeIcon icon={faPhoneAlt} className="hover:text-[#C5B358] text-gray-300 text-4xl mb-2 sm:mb-0" />
            <div className="text-left sm:ml-4">
              <p>
                (+260) 211 255 339 <br />
                (+260) 955 362 614 
              </p>
            </div>
          </div>

          {/* Column 3: Email Address */}
          <div className="mb-8 flex flex-col sm:flex-row items-center justify-center">
            <FontAwesomeIcon icon={faEnvelope} className="hover:text-[#C5B358] text-gray-300 text-4xl mb-2 sm:mb-0" />
            <p className="text-left sm:ml-4">
              <a href="mailto:sales@ibs.co.zm" className="text-white hover:text-blue-500">
                sales@ibs.co.zm
              </a>
            </p>
          </div>
        </div>
        <hr className="my-4 border-[#C5B358]" />
        {/* Copyright Section */}
        <p className="text-sm text-center">
          Copyright &copy; {new Date().getFullYear()} 
          <span className="text-[#C5B358]"> Integrated Business Solutions Ltd</span>. All rights reserved.
        </p>

        <div className="space-x-4 mt-4 text-center">
          {socialMediaLinks.map(({ href, icon, color, label }) => (
            <a
              key={label}
              href={href}
              className={`${color} hover:text-white`}
              aria-label={label}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={icon} className="text-2xl" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
